import React, {useEffect} from "react";
import {Button, Row, Col, Space, Form, Input, message} from "antd";
import {InputFields} from "components/common";
import Icon from "assets/icons";
import {FIELD_TYPE} from "types/enums";
import {FORMAT_TIME} from "types/enums/format-time";
import {MultiField} from "types/models";
import FreeList from "components/common/FreeList/FreeList";
import {convertIosDateToString, formatDateToString} from "helper/common";
import moment from "moment";
import dayjs from "dayjs";
const HandleForm = () => {
  const [form] = Form.useForm();
  useEffect(() => {
    form.setFieldsValue({score: {often: 0, exam: 0}});
  }, []);

  //   Tìm hiểu các hàm của form

  const onFinish = values => {
    message.info("Mở console để xem kết quả");
  };

  const customValidator = (_, value) => {
    if (value?.length >= 3) {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  };

  const formListValidator = async (_, list) => {
    if (!list || list.length < 1) {
      return Promise.reject(new Error());
    } else {
      Promise.resolve();
    }
  };
  const dateString = "1999-02-01T17:00:00.000+00:00";
  const dataFields = [
    {
      type: FIELD_TYPE.INPUT,
      label: "Tên",
      name: "name",
      value: "123",
      // rules: [
      //   {required: true, message: "Chưa nhập tên đăng nhập"},
      //   {min: 5, message: "Ít nhất 5 kí tự"},
      // ],
    },

    {
      type: FIELD_TYPE.DATE,
      label: "Ngày sinh",
      name: "birthday",
      rules: [],
      optionsTime: {showTime: false, format: FORMAT_TIME.dayFull},
    },
    {
      type: FIELD_TYPE.INPUT,
      label: "Địa chỉ",
      name: "address",
      // rules: [
      //   {
      //     validator: customValidator,
      //     message: "Phải nhập ít nhất 3 kí tự",
      //   },
      // ],
    },
    {
      type: FIELD_TYPE.INPUT,
      label: "Điểm thường xuyên",
      name: ["score", "often"],
    },
    {
      type: FIELD_TYPE.INPUT,
      label: "Điểm thi",
      name: ["score", "exam"],
    },
    {
      type: FIELD_TYPE.LIST,
      formList: {
        name: "skills",
        // rules: [
        //   {
        //     validator: formListValidator,
        //     message: "Phải có ít nhất 1 kĩ năng",
        //   },
        // ],
        // initialValue: [{name: ""}],
      },
    },
    {
      type: FIELD_TYPE.AUTO_COMPLETE,
      name: "auto_complete",
      options: [
        {value: "Nguyễn Văn A", label: "Nguyễn Văn A"},
        {value: "Nguyễn Văn B", label: "Nguyễn Văn B"},
        {value: "Nghiêm Phương A", label: "Nghiêm Phương A"},
      ],
    },
    {
      type: FIELD_TYPE.CURRENCY,
      name: "currency",
      label: "Giá tiền",
      autoFocus: true,
    },
    {
      type: FIELD_TYPE.CODE,
      name: "code",
      label: "Code",
    },
  ];

  return (
    <div className="handle-form container">
      <Form
        labelAlign="left"
        form={form}
        onFinish={onFinish}
        labelCol={{span: 4}}
        wrapperCol={{span: 8}}
        onValuesChange={(changedValues, values) => {}}
      >
        <Row gutter={[16, 16]}>
          <InputFields data={dataFields} />
        </Row>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
export default HandleForm;
